import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import HomePage from '../screens/home';
import ToursPage from '../screens/tours';
import TourInnerPage, { ResetAppTour } from '../screens/tours-inner';
import HotelPage from '../screens/hotel';
import NearByHotelPage from '../screens/hotel-nearby';
import { withScrollBarsAndFooter } from '../hocs'
import { Header } from '../components';

export const languageUrlPart = '/:language(en|de|it|es|ro)'

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
export default () => {
    // There is no top level rerender when a redirect to /en is triggered so the language will be mismatched in i18next
    const { i18n: { languages: [language] } } = useTranslation();
    return (
        <>
            <Header/>
            <Switch>
                <Route path={`${languageUrlPart}`} exact component={HomePage} />
                <Route path={`${languageUrlPart}/hotel`} component={withScrollBarsAndFooter(HotelPage)} />
                <Route path={`${languageUrlPart}/near-by-hotel`} component={withScrollBarsAndFooter(NearByHotelPage)} />
                <Route path={[
                    `${languageUrlPart}/around-me`,
                    `${languageUrlPart}/:countrySlug`,
                    `${languageUrlPart}/:countrySlug/find`,
                    `${languageUrlPart}/:countrySlug/:regionSlug`,
                    `${languageUrlPart}/:countrySlug/:regionSlug/:citySlug`,
                    `${languageUrlPart}/:countrySlug/:regionSlug/:citySlug/:tourSlug/nearby`
                ]} render={props =>
                    <>
                        <Switch>
                            <Route path={`${languageUrlPart}/:countrySlug/:regionSlug/:citySlug/:tourSlug`} exact component={TourInnerPage} />
                            <Route component={ResetAppTour}/>
                        </Switch>
                        <ToursPage {...props}/>
                    </>
                } />
                <Redirect to={`/${language}`} />
            </Switch>
        </>
    )
}